import { render, staticRenderFns } from "./SatellitePanel.vue?vue&type=template&id=1d8ffe1c&scoped=true&"
import script from "./SatellitePanel.vue?vue&type=script&lang=js&"
export * from "./SatellitePanel.vue?vue&type=script&lang=js&"
import style0 from "./SatellitePanel.vue?vue&type=style&index=0&id=1d8ffe1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ffe1c",
  null
  
)

export default component.exports